import {UnorderedListOutlined} from '@ant-design/icons';
import {JKUserFreeLogManager} from 'components/Backend/JKUser/FreeLog/Manager';
export const title = '捷克置頂記錄查詢';

export const orderNum = 2;

export const icon = <UnorderedListOutlined />;

export default JKUserFreeLogManager;
